import * as React from 'react';
import cx from 'classnames';
import StringWidget from 'components/StringWidget';
import Button from 'components/Button/Button';
const MessageContainer = (props) => {
    const { styles, message = '' } = props;
    const buttonStyles = cx(styles['submit-btn'], styles['white-btn'], styles['info-contact-btn']);
    return (<div className={styles['info-container']}>
			<div className={styles['info-title']}>
				<StringWidget strKey="loginVerificationBlockedTitle"/>
			</div>
			<div className={styles['info-msg']}>{message}</div>
			<div className={styles['info-help-wrapper']}>
				<div className={styles['info-help-txt']}>
					<StringWidget strKey="loginVerificationBlockedHelpText"/>
				</div>
				<Button external href="/helpcentre" className={buttonStyles}>
					<StringWidget strKey="contactUs"/>
				</Button>
			</div>
		</div>);
};
export default MessageContainer;
